module.exports = __webpack_public_path__ + "img/prva-info.svg";